import { useContext } from 'react';
import { AppContextInfoContext } from './app-context-info.context';
import { QueryParamsContext } from './query-params.context';

export function useShowUserLoginGuide() {
  const { appContext } = useContext(AppContextInfoContext);
  const { showLoginGuide } = useContext(QueryParamsContext);
  if (!showLoginGuide || appContext.userIdentityInfo.isAuthenticated) {
    return false;
  }
  return true;
}
